import { render, staticRenderFns } from "./HubCourierList.vue?vue&type=template&id=1749e036"
import script from "./HubCourierList.vue?vue&type=script&lang=js"
export * from "./HubCourierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports